(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["fc-customer-photos"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('fc-review-evidence')) customElements.define('fc-review-evidence',class extends HTMLElement{
 connectedCallback(){
  this.grid=this.querySelector('.fc-evidence-photos');
  this.reviewContext=row=>{
   const values=[
    row.getAttribute('data-variant-title'),
    row.getAttribute('data-variant'),
    row.querySelector('.jdgm-rev__variant')?.textContent,
    row.querySelector('.jdgm-rev__product-variant')?.textContent
   ];
   return values.map(value=>value?.replace(/\s+/g,' ').trim()).find(Boolean)||'';
  };
  this.reviewRating=row=>{
   const ratingEl=row.querySelector('.jdgm-rev__rating');
   const values=[
    ratingEl?.getAttribute('data-score'),
    ratingEl?.getAttribute('data-rating'),
    row.getAttribute('data-score'),
    row.getAttribute('data-rating'),
    row.getAttribute('data-review-rating')
   ];
   for(const value of values){
    if(value==null||value==='')continue;
    const rating=Number.parseFloat(value);
    if(Number.isFinite(rating)&&rating>=1&&rating<=5)return Math.round(rating*10)/10;
   }
   const label=ratingEl?.getAttribute('aria-label')||'';
   const match=label.match(/(\d(?:\.\d+)?)\s*(?:out of|\/)\s*5/i);
   if(match){const rating=Number.parseFloat(match[1]);if(Number.isFinite(rating)&&rating>=1&&rating<=5)return Math.round(rating*10)/10;}
   return null;
  };
  this.sync=()=>{
   const widget=document.getElementById('judgeme_product_reviews');if(!widget)return;
   if(!widget.querySelector('.fc-evidence-back')){const back=document.createElement('a');back.className='fc-evidence-back';back.href='#fc-review-evidence';back.textContent=this.dataset.back;widget.prepend(back);}
   const rows=Array.from(widget.querySelectorAll('.jdgm-rev')).filter(row=>{
    const url=row.getAttribute('data-product-url');const name=row.querySelector('.jdgm-rev__author')?.textContent||'';
    return (!url||url===this.dataset.productUrl)&&row.querySelector('.jdgm-rev__pic-link img')&&!/\btest\b/i.test(name);
   }).slice(0,3);
   const key=rows.map(row=>(row.getAttribute('data-review-id')||'')+':'+(this.reviewRating(row)??'')).join('|');if(key===this.key)return;this.key=key;
   this.grid.replaceChildren();this.grid.hidden=rows.length===0;
   rows.forEach(row=>{
    const source=row.querySelector('.jdgm-rev__pic-link img');const src=source.getAttribute('src')||source.getAttribute('data-src');if(!src)return;
    const button=document.createElement('button');button.type='button';button.className='fc-evidence-photo';
    const img=document.createElement('img');img.src=src;img.alt=source.alt;img.width=114;img.height=114;img.loading='lazy';
    const author=row.querySelector('.jdgm-rev__author')?.textContent.trim()||'';const context=this.reviewContext(row);const rating=this.reviewRating(row);
    button.append(img);
    if(rating!==null){const ratingLine=document.createElement('span');ratingLine.className='fc-evidence-rating';ratingLine.textContent='★ '+(Number.isInteger(rating)?rating.toFixed(0):rating.toFixed(1))+'/5';ratingLine.setAttribute('aria-label',rating+' out of 5 stars');button.append(ratingLine);}
    const caption=document.createElement('span');caption.className='fc-evidence-caption';caption.textContent=this.dataset.read+(author?' · '+author:'')+(context?' · '+context:'');
    button.append(caption);button.addEventListener('click',()=>{row.setAttribute('tabindex','-1');row.scrollIntoView({block:'center',behavior:'auto'});row.focus({preventScroll:true});});this.grid.append(button);
   });
  };
  this.scheduleSync=()=>{clearTimeout(this.pending);this.pending=setTimeout(this.sync,120);};
  this.attachWidgetObserver=()=>{
   const widget=document.getElementById('judgeme_product_reviews');
   if(!widget)return false;
   if(this.widget===widget)return true;
   this.widget=widget;
   this.discoveryObserver?.disconnect();
   this.widgetObserver?.disconnect();
   this.sync();
   this.widgetObserver=new MutationObserver(this.scheduleSync);
   this.widgetObserver.observe(widget,{childList:true,subtree:true,attributes:true,attributeFilter:['data-score','data-rating','data-review-rating','src','data-src']});
   return true;
  };
  if(!this.attachWidgetObserver()){
   this.discoveryObserver=new MutationObserver(()=>this.attachWidgetObserver());
   this.discoveryObserver.observe(document.querySelector('main')||document.body,{childList:true,subtree:true});
  }
 }
 disconnectedCallback(){this.discoveryObserver?.disconnect();this.widgetObserver?.disconnect();clearTimeout(this.pending);}
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["fc-delivery-estimate"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('fc-delivery-estimate')){
 customElements.define('fc-delivery-estimate',class extends HTMLElement{
  connectedCallback(){
   this.options=JSON.parse(this.querySelector('[data-options]').textContent);
   this.output=this.querySelector('[data-date]');
   this.mumbai=this.querySelector('[data-mumbai-date]');
   this.update=()=>{
    if(document.hidden)return;
    const info=this.closest('.product__info-container');
    const id=info?.querySelector('form[action*="/cart/add"] [name="id"]')?.value||this.dataset.default;
    const parts=new Intl.DateTimeFormat('en-GB',{timeZone:'Asia/Kolkata',year:'numeric',month:'2-digit',day:'2-digit'}).formatToParts(new Date());
    const part=t=>Number(parts.find(p=>p.type===t).value);
    const today=new Date(Date.UTC(part('year'),part('month')-1,part('day'),12));
    const key=id+today.toISOString();if(key===this.lastKey)return;this.lastKey=key;
    if(!this.options[id]){this.mumbai.textContent='';this.output.textContent=this.dataset.check;return;}
    const addDays=n=>{const d=new Date(today);let remaining=n;while(remaining>0){d.setUTCDate(d.getUTCDate()+1);if(d.getUTCDay()!==0&&d.getUTCDay()!==6)remaining--;}return d;};
    const format=d=>new Intl.DateTimeFormat('en-IN',{day:'numeric',month:'short',timeZone:'UTC'}).format(d);
    this.mumbai.textContent=this.dataset.mumbai+' — '+this.dataset.label+' '+format(addDays(Number(this.dataset.mumbaiMin)))+' – '+format(addDays(Number(this.dataset.mumbaiMax)));
    this.output.textContent=this.dataset.india+' — '+this.dataset.label+' '+format(addDays(Number(this.dataset.min)))+' – '+format(addDays(Number(this.dataset.max)));
   };
   this.update();this.timer=setInterval(this.update,1000);
  }
  disconnectedCallback(){clearInterval(this.timer);}
 });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["fc-mobile-shopping"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('fc-mobile-shopping')){
  customElements.define('fc-mobile-shopping',class extends HTMLElement{
    connectedCallback(){
      this.info=document.querySelector('.product__info-container');
      this.purchase=this.info?.querySelector('.product-form__buttons');
      if(!this.info||!this.purchase)return;
      this.button=this.querySelector('button');
      this.update=()=>{
        const current=document.querySelector('.product__info-container .product-form__buttons');
        if(!current){this.hidden=true;return;}
        if(current!==this.purchase){this.purchase=current;this.observer.disconnect();this.observer.observe(current);}
        const rect=this.purchase.getBoundingClientRect();
        const dialog=document.querySelector('dialog[open], details[open].menu-opening, .drawer.active, .product-media-modal[open]');
        this.hidden=rect.bottom>=0||Boolean(dialog);
      };
      this.returnToOptions=()=>{
        this.hidden=true;
        this.info.scrollIntoView({behavior:'instant',block:'start'});
        const target=this.info.querySelector('.product__title');
        if(target){target.setAttribute('tabindex','-1');target.focus({preventScroll:true});}
      };
      this.button.addEventListener('click',this.returnToOptions);
      this.observer=new IntersectionObserver(this.update,{threshold:[0,1]});
      this.observer.observe(this.purchase);
      this.dialogObserver=new MutationObserver(this.update);
      this.dialogObserver.observe(document.body,{subtree:true,childList:true,attributes:true,attributeFilter:['open','class']});
      this.update();
    }
    disconnectedCallback(){
      this.observer?.disconnect();this.dialogObserver?.disconnect();
      this.button?.removeEventListener('click',this.returnToOptions);
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
